import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FileDown, FileSpreadsheet, AlertTriangle, ReceiptText } from 'lucide-react';

// CARİ HESAP EKSTRESİ — girişsiz paylaşım sayfası (/ekstre/:token).
// Tedarikçiye WhatsApp ile gider (components/WhatsAppGonder, modul cari_ekstre).
// Token imzalı ve süreli (varsayılan 1 gün); veri GÜNCEL — sayfa her açılışta
// sunucudan okunur (routes/paylasim.py). JWT'li `lib/api.js` kasıtlı olarak
// kullanılmıyor (PublicDailyReportForm.js'teki not).
const API = `${window.location.origin}/api/erp/paylasim/ekstre`;

const sayi = (v) => {
  const n = Number(v || 0);
  return (Math.abs(n) < 0.005 ? 0 : n).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
const tarih = (d) => (d ? `${String(d).slice(8, 10)}.${String(d).slice(5, 7)}.${String(d).slice(0, 4)}` : '');

export default function PublicEkstre() {
  const { token } = useParams();
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState(null);
  const [indiriliyor, setIndiriliyor] = useState(null);

  useEffect(() => {
    document.title = 'Cari Hesap Ekstresi';
    (async () => {
      try {
        const r = await fetch(`${API}/${token}`);
        const g = await r.json().catch(() => ({}));
        if (!r.ok) { setHata(g.detail || 'Bağlantı geçersiz ya da süresi dolmuş.'); return; }
        setVeri(g);
      } catch { setHata('Sunucuya ulaşılamadı. Lütfen daha sonra tekrar deneyin.'); }
    })();
  }, [token]);

  const indir = async (bicim) => {
    setIndiriliyor(bicim);
    try {
      const r = await fetch(`${API}/${token}/${bicim}`);
      if (!r.ok) { setHata('Bağlantının süresi dolmuş olabilir.'); return; }
      const cd = r.headers.get('content-disposition') || '';
      const ad = (/filename="?([^";]+)"?/i.exec(cd) || [])[1] || `Ekstre.${bicim}`;
      const url = URL.createObjectURL(await r.blob());
      const a = document.createElement('a');
      a.href = url; a.download = ad; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } finally { setIndiriliyor(null); }
  };

  if (hata) {
    return (
      <div className="min-h-screen bg-[#f5f1e8] flex items-center justify-center p-6">
        <div className="max-w-sm text-center space-y-3" data-testid="ekstre-hata">
          <AlertTriangle size={36} className="mx-auto text-[#9b3b2f]" />
          <p className="text-[#1a1916] font-semibold">{hata}</p>
          <p className="text-sm text-[#8a7e70]">Güncel ekstre için firmamızdan yeni bağlantı isteyebilirsiniz.</p>
        </div>
      </div>
    );
  }
  if (!veri) {
    return <div className="min-h-screen bg-[#f5f1e8] flex items-center justify-center text-[#8a7e70]">Yükleniyor…</div>;
  }

  const satirlar = [...veri.satirlar].reverse();   // yeni → eski
  const pbler = Object.keys(veri.kapanis || {});

  return (
    <div className="min-h-screen bg-[#f5f1e8] px-3 py-5 sm:px-6" data-testid="ekstre-sayfasi">
      <div className="mx-auto max-w-5xl space-y-4">
        <div className="rounded-xl border border-[#d0c4b0] bg-[#faf7f2] p-4 sm:p-5">
          <p className="text-xs font-semibold uppercase tracking-wider text-[#8a7e70]">{veri.sirket}</p>
          <h1 className="mt-1 flex items-center gap-2 text-xl font-bold text-[#1a1916]">
            <ReceiptText size={20} /> Cari Hesap Ekstresi
          </h1>
          <p className="mt-1 text-sm text-[#3F3E39]">
            <b>{veri.hesap_adi}</b>{veri.hesap_kodu ? ` · ${veri.hesap_kodu}` : ''}
            {veri.filtre ? <span className="text-[#8a7e70]"> · {veri.filtre}</span> : null}
          </p>
          <p className="mt-0.5 text-xs text-[#8a7e70]">
            {new Date().toLocaleString('tr-TR')} itibarıyla güncel
            {veri.gecerlilik ? ` · bağlantı ${new Date(veri.gecerlilik).toLocaleString('tr-TR')} tarihine kadar geçerli` : ''}
          </p>

          <div className="mt-3 flex flex-wrap gap-2">
            {pbler.map(pb => (
              <div key={pb} className="rounded-lg border border-[#d0c4b0] bg-white px-3 py-2">
                <p className="text-[10px] uppercase text-[#8a7e70]">Bakiye ({pb})</p>
                <p className={`font-mono font-semibold ${veri.kapanis[pb] < 0 ? 'text-[#9b3b2f]' : 'text-[#1a1916]'}`}>
                  {sayi(veri.kapanis[pb])}
                </p>
              </div>
            ))}
            {Object.entries(veri.vade_gelen || {}).filter(([, t]) => Math.abs(t) >= 0.005).map(([pb, t]) => (
              <div key={`v-${pb}`} className="rounded-lg border border-[#d0c4b0] bg-white px-3 py-2">
                <p className="text-[10px] uppercase text-[#8a7e70]">Vadesi gelen ({pb})</p>
                <p className="font-mono font-semibold text-[#7a6a2e]">{sayi(t)}</p>
              </div>
            ))}
          </div>

          <div className="mt-3 flex gap-2">
            <Button size="sm" variant="outline" onClick={() => indir('pdf')} disabled={!!indiriliyor}
              className="border-[#d0c4b0] text-[#7a3535]" data-testid="ekstre-pdf-indir">
              <FileDown size={14} className="mr-1" /> {indiriliyor === 'pdf' ? 'Hazırlanıyor…' : 'PDF indir'}
            </Button>
            <Button size="sm" variant="outline" onClick={() => indir('xlsx')} disabled={!!indiriliyor}
              className="border-[#d0c4b0] text-[#3d6e4e]" data-testid="ekstre-excel-indir">
              <FileSpreadsheet size={14} className="mr-1" /> {indiriliyor === 'xlsx' ? 'Hazırlanıyor…' : 'Excel indir'}
            </Button>
          </div>
        </div>

        <div className="overflow-x-auto rounded-xl border border-[#d0c4b0] bg-white">
          <table className="w-full text-sm">
            <thead className="bg-[#faf7f2] text-left text-xs text-[#5c554b]">
              <tr>
                <th className="px-3 py-2">Tarih</th><th className="px-3 py-2">Vade</th>
                <th className="px-3 py-2">Belge No</th><th className="px-3 py-2">Açıklama</th>
                <th className="px-3 py-2">Tür</th><th className="px-3 py-2 text-right">Tutar</th>
                <th className="px-3 py-2 text-right">Bakiye</th>
              </tr>
            </thead>
            <tbody>
              {satirlar.length === 0 && (
                <tr><td colSpan={7} className="px-3 py-6 text-center text-[#8a7e70]">Hareket yok</td></tr>
              )}
              {satirlar.map((s, i) => (
                <tr key={i} className="border-t border-[#efe8dc]">
                  <td className="px-3 py-1.5 whitespace-nowrap">{tarih(s.tarih)}</td>
                  <td className="px-3 py-1.5 whitespace-nowrap text-[#8a7e70]">{tarih(s.vade)}</td>
                  <td className="px-3 py-1.5 font-mono text-xs">{s.belge_no}</td>
                  <td className="px-3 py-1.5 min-w-[10rem]">{s.aciklama}</td>
                  <td className="px-3 py-1.5 whitespace-nowrap">{s.tur}</td>
                  <td className={`px-3 py-1.5 text-right font-mono whitespace-nowrap ${s.tutar < 0 ? 'text-[#9b3b2f]' : 'text-[#3d6e4e]'}`}>
                    {sayi(s.tutar)} <span className="text-[10px] text-[#8a7e70]">{s.para_birimi}</span>
                  </td>
                  <td className={`px-3 py-1.5 text-right font-mono whitespace-nowrap ${s.bakiye < 0 ? 'text-[#9b3b2f]' : ''}`}>
                    {sayi(s.bakiye)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-center text-[11px] text-[#a3968a]">Bu sayfa {veri.sirket} tarafından paylaşılmıştır.</p>
      </div>
    </div>
  );
}
